let mapsLoaderPromise;

export async function ensureMapsLoaded(apiKey) {
	// SSR guard
	if (typeof window === 'undefined') {
		return;
	}

	// Already available?
	if (window.google?.maps?.importLibrary) {
		await window.google.maps.importLibrary('places');
		return;
	}

	// Reuse in-flight load
	if (mapsLoaderPromise) {
		await mapsLoaderPromise;
		await window.google.maps.importLibrary('places');
		return;
	}

	const existing = document.querySelector('script[data-google-maps]');

	mapsLoaderPromise = new Promise((resolve, reject) => {
		const onError = (err) => {
			reject(err instanceof Event ? new Error('Google Maps failed to load') : err);
		};

		const onLoad = () => {
			if (window.google && window.google.maps && window.google.maps.importLibrary) {
				if (existing) {
					existing.removeEventListener('load', onLoad);
					existing.removeEventListener('error', onError);
				}
				resolve();
			}
		};

		if (existing) {
			existing.addEventListener('load', onLoad);
			existing.addEventListener('error', onError);
			onLoad();
		} else {
			const s = document.createElement('script');
			s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly`;
			s.async = true;
			s.defer = true;
			s.setAttribute('data-google-maps', 'true');
			s.addEventListener('load', onLoad);
			s.addEventListener('error', onError);
			document.head.appendChild(s);
		}
	});

	await mapsLoaderPromise;
	await window.google.maps.importLibrary('places');
}
